<template>
  <div>
    <div class="wrap coach-recom-wrap pb-30">
      <div class="top-header">
        <incBack></incBack>
        <h3>예약하기</h3>
      </div>
      <div class="body-wrap">
        <div class="recomm">
          <h4>
            나에게 딱 맞는<br />
            <span class="bold">코치 추천! </span>
          </h4>
          <div class="coach-slide">
            <div>
              <div v-if="isLoading">
                <VueSlickCarousel v-bind="settings">
                  <div v-for="(item, index) in coachs" :key="index" @click="pushDetailPage(item.coarIdx)" class="coach-card">
                    <div class="clear profile">
                      <img src="@/assets/img/coach_bg.png" class="bg" />
                      <img :src="item.coarPic" class="profile-img" alt="코치 이미지" style="width: 100%" />
                      <div v-if="item.isLastReserved === 'Y'" class="card-point clear">
                        <img src="@/assets/img/return.svg" />
                        <p>이번 코칭도 {{ item.userName }} 코치님과<br />계속 이어가 보세요.</p>
                      </div>
                    </div>
                    <div class="info">
                      <h1>{{ item.userName }} <span>코치</span></h1>
                      <p>{{ item.coarOnelineIntroduction }}</p>
                    </div>
                  </div>
                </VueSlickCarousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import incBack from "@/components/inc/inc_back.vue";
export default {
  name: "coach_recom",
  props: {
    rebook: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    settings: {
      dots: false,
      infinite: false,
      centerMode: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
    },
    coachs: [],
    isLoading: false,
  }),
  components: {
    VueSlickCarousel,
    incBack,
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      // 지정코치 리스트 호출
      this.coachs = await this.getCoachs();

      this.isLoading = true;
    },

    async getCoachs() {
      const params = {
        courseIdx: this.$store.state.userInfo.courseIdx,
        userIdx: this.$store.state.userInfo.userIdx,
      };
      const result = await this.axios.get("/front/user/recommendCoarch/last", { params });

      if (result.data.success) {
        return result.data.data;
      } else {
        return [];
      }
    },

    pushDetailPage(idx) {
      this.$router.push({ name: "coach_view", params: { idx: idx, rebook: this.rebook } });
    },
  },
};
</script>
